import { User, RoleCode } from "../components/users/store/slice";

export const hasRole = (user: User, roleCode: RoleCode) =>
  user && user.roles
    ? !!user.roles.find((role) => role.code === roleCode)
    : false;
